module.exports = __webpack_public_path__ + "img/product-3-swim.35035072.png";